import { pointsBadgeClass } from "../../lib/badges";
import { useI18n } from "../../i18n";

// Display-only badge — mirrors backend scoring rules.
export default function PointsBadge({ pred, match }) {
    const { t } = useI18n();
    const h = pred.home_goals === match.home_goals ? 2 : 0;
    const a = pred.away_goals === match.away_goals ? 2 : 0;
    const sign = (x, y) => x > y ? "H" : x < y ? "A" : "D";
    const o = sign(pred.home_goals, pred.away_goals) === sign(match.home_goals, match.away_goals) ? 3 : 0;
    const total = h + a + o;
    return (
        <span data-testid={`points-${match.id}`} className={`text-[10px] font-extrabold uppercase tracking-widest px-2 py-1 rounded ${pointsBadgeClass(total)}`}>
            {t("fix.points", { n: total })}
        </span>
    );
}
